import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { findAll } from './actions';
import { selectBalances } from './balancesSlice';

export const FetchAllBalancesEffect = (): void => {
  const balances = useAppSelector(selectBalances);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if ( balances === null) {
      dispatch(findAll());
    }
  }, [dispatch, balances]);
};

